import { useEffect, useState } from 'react';
import { useUser } from '../../../providers/UserContext';
import { firestore } from '../../../firebase/firebase';
import moment from 'moment';
import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid'

const useTicket = () => {
    const { getUsers, users } = useUser();

    useEffect(() => { 
        getUsers()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const [defaultTicket] = useState({
        ticket: "Unnumbered",
        date: moment().format("YYYY-MM-DD").valueOf(),
        customerId: null,
        rate: null,
        notes: '', 
        uid: null,
        units: [null, null, null],
        cartageSaleUnits: 0,
        cartageSaleRate: "0.00",
        cartageSalesPer: null,
        cartageSalesTotal: "0.00",
        payrollRate: "0.00",
        payrollUnits: 0,
        payrollPer: null,
        payroll: "0.00",
        payrollAdjustedBase: "0.00",   
        payrollMultiplier: "100.00",
        linkOperatorToSalesRate: false,
        material: null,
        materialSalesRate:"0.00",
        quantity: 0,
        materialSalesTotal: "0.00",
        operatorPayDate: null,
        invoicePayDate: null,
        dataEntryDate: moment().valueOf(),
        //percentageFuelSurcharge: "0.00",
        //dollarFuelSurcharge: "0.00",
        //percentageCabonFee: "0.00",
        //dollarCarbonFee: "0.00",
        from: '',
        to: '',
        timeIn: null,
        timeOut: null,
        nextDay: false, 
        sourceCollection: null,
        // payrollVerified: false,
        invoiceVerified: false,  
        ticketBatchId: null,
    })

    const getIndexOfJobInTimesheet = (job) => {
        return new Promise((resolve) => {
            firestore.collection('jobs').where('timesheetID', '==', job.timesheetID).orderBy('date').get()
            .then(querySnapshot => {
                const response = querySnapshot.docs.map((doc) => {
                    return {
                        ...doc.data(),
                        'docId': doc.id,
                    }
                })

                for(let index = 0; index < response.length; index++){
                    if(response[index].docId === job.docId){
                        return resolve(!_.isUndefined(index) ? index : 'NA')
                    }
                }
                return resolve('NA')
            })
            .catch(e => {
                console.warn(e)
                return resolve('NA')
            })
        })
    }

    const getParentUnitNumber = (unitDocId) => {
        return new Promise((resolve) => {
            firestore.collection('units').doc(unitDocId).get()
            .then(doc => { 
                resolve(doc.data()?.unitNumber || 'NA') 
            })
            .catch(e => {
                console.warn(e)
                return resolve('NA')
            })
        })
    }

    const getTimesheetIDFromJob = (timesheedDocId) => {
        return new Promise((resolve) => {
            firestore.collection('timesheets').doc(timesheedDocId).get()
            .then(doc => { 
                resolve(doc.data().timesheetID || 'NA') 
            })
            .catch(e => {
                console.warn(e)
                return resolve('NA')
            })
        })
    }

    const getJobTicketNumber = async (job, batch, index) => {
        return new Promise((resolve) => {
            let promises = [getIndexOfJobInTimesheet(job), getParentUnitNumber(job.units[0]), getTimesheetIDFromJob(job.timesheetID)]
            Promise.all(promises).then((res) => {
                let date = moment(job.date).format('YYYYMMDD') || 'NA';
                let userInitials = users.find(x=> x.uuid === job.uid).displayName.match(/\b(\w)/g).join('');
                let entryNum = res[0]
                let unitNumber = res[1]
                let timesheetId = res[2]

                if(batch){ return resolve(`${unitNumber}-${date}-${userInitials}-${timesheetId}-${entryNum}-${index}`) }
                else{ return resolve(`${unitNumber}-${date}-${userInitials}-${timesheetId}-${entryNum}`) }
            })
        })
    }

    //returns true if any documents already have an associated ticket, else return false
    const batchCheckForAssociatedTickets = (docIdArray, collection) => {
        return new Promise(async (resolve) => {
            let promiseArray = []
            for(let docId of docIdArray){ promiseArray.push(firestore.collection(collection).doc(docId).get()); }

            Promise.all(promiseArray).then(querySnapshots => {
                let value = querySnapshots.map(doc => { return {...doc.data(),'docId': doc.id} });

                //if any values have associatedTicket return true, else return false
                for(const x of value){ if(!_.isEmpty(x.associatedTickets)){ return resolve(true) }}
                return resolve(false)
            })
        })
    }

    const createTicketFromSource = (convertToTicketArray, globalChanges, source, batchByUnit) => {
        return new Promise(async (resolve, reject) => {
            try{
                if(!convertToTicketArray || !globalChanges || !source){throw new Error('Create Ticket arguments not complete.')}
                if(await batchCheckForAssociatedTickets(convertToTicketArray.map(x=> x.docId), source)){ 
                    throw new Error('One of these documents is already associated with a ticket, please refesh your data and try again.') 
                }

                let secondArgIsArray = null
                if(typeof globalChanges === 'object' && Array.isArray(globalChanges)){ secondArgIsArray = true }
                else if(typeof globalChanges === 'object' && !Array.isArray(globalChanges)){ secondArgIsArray = false }
                else{ throw new Error('Second argument in send to ticket is in the wrong type.') }

                let allContainer = _.cloneDeep(globalChanges)
                let indexContainer = secondArgIsArray ? allContainer.findIndex(x=> x.docId === convertToTicketArray[0].docId) : null
                let sourceContainer = secondArgIsArray ? _.cloneDeep(allContainer[indexContainer]) : _.cloneDeep(allContainer)
                let associatedTicketsContainer = [];
                let batch = firestore.batch();

                //seperate each convertToTicketArray with each unit as its own ticket
                if(batchByUnit){
                    let newArray = []
                    convertToTicketArray.forEach((ticket) => {
                        let batchId = uuidv4()
                        // let currentTime = 
                        ticket.units.forEach((unit) => {
                            let container = _.cloneDeep(ticket)
                            container.ticketBatchId = batchId

                            //alter units
                            container.units = [unit, null, null]

                            //alter time

                            newArray.push(container)
                        })
                    })
                    convertToTicketArray = newArray;
                }

                for (const [index, container] of convertToTicketArray.entries()){
                    let ticketContainer = null;
                    
                    switch(source) {
                        case 'deliveries':
                            ticketContainer = {
                                ticket: container.ticket || "Unnumbered",
                                date: moment(container.date).format('YYYY-MM-DD') || moment().format('YYYY-MM-DD'),
                                customerId: container.customerId || null,
                                rate: null,
                                notes: container.notes || '', 
                                uid: container.uid || null,
                                units: [container.units[0] || null, container.units[1] || null, container.units[2] || null],
                                cartageSaleUnits: 0,
                                cartageSaleRate: "0.00",
                                cartageSalesPer: null,
                                cartageSalesTotal: "0.00",
                                payrollRate: users.find(x=> x.uuid === container.uid)?.payroll?.percentagePayRate || "0.00",
                                payrollUnits: 0,
                                payrollPer: null,
                                payroll: "0.00",
                                payrollAdjustedBase: "0.00",   
                                payrollMultiplier: "100.00",
                                linkOperatorToSalesRate: !_.isUndefined(users.find(x=> x.uuid === container.uid)?.payroll?.percentagePayRate) ? true : false,
                                material: container.material || null,
                                materialSalesRate:"0.00",
                                quantity: container.quantity,
                                materialSalesTotal: "0.00",
                                invoicePayDate: null,
                                dataEntryDate: moment().valueOf(),
                                percentageFuelSurcharge: "0.00",
                                dollarFuelSurcharge: "0.00",
                                percentageCabonFee: "0.00",
                                dollarCarbonFee: "0.00",
                                from: container.from || '',
                                to: container.to || '',
                                timeIn: null,
                                timeOut: null,
                                nextDay: false, 
                                sourceCollection: 'deliveries',
                                invoiceVerified: false,
                                ticketBatchId: container.ticketBatchId || null,
                                operatorPayDate: null,
                            }
                            break;
                        case 'jobs':
                            ticketContainer = {
                                ticket: await getJobTicketNumber(container, batchByUnit, index),
                                date: moment(container.date).format('YYYY-MM-DD') || moment().format('YYYY-MM-DD'),
                                customerId: container.customerID || null,
                                rate: null,
                                notes: container.notes || '', 
                                uid: container.uid || null,
                                units: [container.units[0] || null, container.units[1] || null, container.units[2] || null],
                                cartageSaleUnits: 0,
                                cartageSaleRate: "0.00",
                                cartageSalesPer: null,
                                cartageSalesTotal: "0.00",
                                payrollRate: users.find(x=> x.uuid === container.uid)?.payroll?.percentagePayRate || "0.00",
                                payrollUnits: 0,
                                payrollPer: null,
                                payroll: "0.00",
                                payrollAdjustedBase: "0.00",
                                payrollMultiplier: "100.00",
                                linkOperatorToSalesRate: !_.isUndefined(users.find(x=> x.uuid === container.uid)?.payroll?.percentagePayRate) ? true : false,
                                material: null,
                                materialSalesRate:"0.00",
                                quantity: 0,
                                materialSalesTotal: "0.00",
                                invoicePayDate: null,
                                dataEntryDate: moment().valueOf(),
                                percentageFuelSurcharge: "0.00",
                                dollarFuelSurcharge: "0.00",
                                percentageCabonFee: "0.00",
                                dollarCarbonFee: "0.00",
                                from: '',
                                to: '',
                                timeIn: container.timeIn || null,
                                timeOut: container.timeOut || null,
                                nextDay: false, 
                                sourceCollection: 'jobs',
                                invoiceVerified: false,
                                ticketBatchId: container.ticketBatchId || null,
                                operatorPayDate: null,
                            }
                            break;
                        default:
                            throw new Error('collection was not properly specified when sending to ticket.')
                    } 

                    //set ticket to batch
                    let query = firestore.collection('ticketEntries').doc()
                    ticketContainer.docId = query.id

                    batch.set(query, ticketContainer);
                    associatedTicketsContainer.push(query.id)
                }
                
                //manipulating global changes object
                if (secondArgIsArray){
                    sourceContainer.associatedTickets = associatedTicketsContainer
                    allContainer.splice(indexContainer, 1, sourceContainer)
                }
                else{
                    sourceContainer.associatedTickets = associatedTicketsContainer
                    allContainer.associatedTickets = associatedTicketsContainer
                }

                //set source collection doc to batch
                let allQuery = firestore.collection(source).doc(sourceContainer.docId)
                batch.update(allQuery, {associatedTickets: associatedTicketsContainer});

                batch.commit()
                .then(() => {
                    console.log(`${source}: commited changes, returning with changes`)
                    resolve(allContainer);
                })
            }
            catch(e){
                reject(e.message)
            }
        })
    }

    return {defaultTicket, createTicketFromSource}
};

export default useTicket